import { render, staticRenderFns } from "./Aquisicao.vue?vue&type=template&id=70b71c40"
import script from "./Aquisicao.vue?vue&type=script&lang=ts"
export * from "./Aquisicao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports